// extracted by mini-css-extract-plugin
export default {"avatar":"rc6nEbjBLvD3GY19Gjp-cQ=="};